import { Typography, Tooltip } from '@mui/material'
import { useRecordContext } from 'react-admin'

const AdresseField = ({ record: propRecord, maxLength = 25, sx = {} }) => {
  const record = propRecord || useRecordContext()

  if (!record) return null

  const adresseComplete = `${record.adresse ?? ''} ${record.codepostal ?? ''} ${
    record.ville ?? ''
  }`.trim()
  const isTruncated = adresseComplete.length > maxLength
  const displayedValue = isTruncated
    ? adresseComplete.substring(0, maxLength) + '…'
    : adresseComplete

  return (
    <Tooltip title={adresseComplete}>
      <Typography variant="body2" sx={sx}>
        {displayedValue}
      </Typography>
    </Tooltip>
  )
}

export default AdresseField
